import { render } from "./BaumRechtlicheHinweiseStep.vue?vue&type=template&id=77aca556&scoped=true"
import script from "./BaumRechtlicheHinweiseStep.vue?vue&type=script&lang=js"
export * from "./BaumRechtlicheHinweiseStep.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=77aca556&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aca556"]])

export default __exports__